import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=230e8148"
import script from "./MemberDetail.vue?vue&type=script&lang=js"
export * from "./MemberDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports